// extracted by mini-css-extract-plugin
module.exports = {"filter":"styles_filter__2bu_p","footerFilter":"styles_footerFilter__1Iu_r","content":"styles_content__3kvQp"};